import SubsectionHeader from '../components/subsection-header/subsection-header';
import SubsectionFooter from '../components/subsection-footer/subsection-footer';
import insuranceKeyMotivator from './insurance-key-motivator';
import insuranceSummary from './insurance-summary';
import { Routes, Route, Link, Outlet, useLocation } from 'react-router-dom';
import './insurance.scss';
import { useState, useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

// References for Financial Section
const insuranceUsageReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."}
];

const insurancelanningReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
];

const insuranceIntegrationReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."}
];

const insuranceMetricsReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."}
];

const insuranceFutureReferences = [
  {reference: "“Direct Mail Industry Research: Insights Report,” Summit Research for McCann Worldgroup, May 2023."},
  {reference: "QR Code is a registered trademark of DENSO WAVE INCORPORATED."},
  {reference: "“<a href='https://www.lob.com/blog/4-direct-mail-marketing-myths-debunked' target='_blank'>4 Direct Mail Marketing Myths Debunked</a>,” Lob, Oct. 4, 2022."}
];

export default function Insurance() {

  const url = useLocation();
  const path = url.pathname;
  const segment = path.substring(path.lastIndexOf('/') + 1);
  const currentSection = "Insurance";
  const keyTakeaways = false;

  // Hero Headings
  
  const h1 = "Insurance";
  const h2 = "Direct Mail in the Insurance Industry:";
  const subtext = "Key Stats and Insights";
  const heroAlt = "Monochromatic purple shapes arranged across a purple gridded background.";

// Initial References - Financial Usage 
  const [references, setReferences] = useState(insuranceUsageReferences);

  useEffect(() => {

    switch (segment) {
      case "insurance": 
        setReferences(insuranceUsageReferences);
        break;
      case "planning": 
        setReferences(insurancelanningReferences);
        break;
      case "integration": 
        setReferences(insuranceIntegrationReferences);
        break;
      case "metrics": 
        setReferences(insuranceMetricsReferences);
        break;
      case "future": 
        setReferences(insuranceFutureReferences);
        break;
    }
    
  }, [url]);

  useEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [url.pathname]);

  return (
    <>
      <div className="insurance">
        <div className='container' data-aos="fade-up">
          <SubsectionHeader currentSection={currentSection} heroAlt={heroAlt} h1={h1} h2={h2} subtext={subtext}/>
          <Outlet />
          <SubsectionFooter currentSection={currentSection} KeyMotivator={insuranceKeyMotivator} Summary={insuranceSummary} references={references} keyTakeaways={keyTakeaways} />
        </div>
      </div>
    </>
  );
}
